<template>
    <modal :id="modalId" title="Unlayer Template Global Settings" @ok="save">
        <div>
            <b-alert show variant="warning" class="mb-3">
                Note: These settings will be applied to all templates.
            </b-alert>

            <form-input v-model="textColor" label="Text Color" placeholder="#000000" type="color" />

            <form-input v-model="backgroundColor" label="Background Color" placeholder="#ffffff" type="color" />

            <form-input v-model.number="contentWidth" type="number" label="Content Width" placeholder="500" />

            <form-select
                v-model="fontFamily"
                label="Font Family"
                :options="fontFamilyOptions"
                placeholder="Select Font Family"
            />
        </div>
    </modal>
</template>

<script>
import Modal from '../../generic/modal/modal.vue';
import FormInput from '../../generic/form-input/form-input.vue';
import FormSelect from '../../generic/form-select/form-select.vue';
import { FONT_FAMILY_OPTIONS } from './constants';
export default {
    name: 'UnlayerTemplateGlobalSettingsModal',
    components: {
        Modal,
        FormInput,
        FormSelect,
    },
    props: {
        modalId: {
            type: String,
            default: 'unlayer-template-global-settings-modal',
        },
        initialSettings: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            // Initialize with defaults or values from props
            textColor: this.initialSettings.textColor || '#000000',
            backgroundColor: this.initialSettings.backgroundColor || '#ffffff',
            contentWidth: this.initialSettings.contentWidth || 500,
            fontFamily: this.initialSettings.fontFamily || 'Arial',

            // Update Font Family Options based on the screenshot
        };
    },
    computed: {
        fontFamilyOptions() {
            return FONT_FAMILY_OPTIONS.map((option) => ({
                text: option.label,
                value: option.value,
            }));
        },
    },
    methods: {
        save() {
            const settings = {
                textColor: this.textColor,
                backgroundColor: this.backgroundColor,
                contentWidth: this.contentWidth,
                fontFamily: {
                    label: this.fontFamilyOptions.find((option) => option.value === this.fontFamily).text,
                    value: this.fontFamily,
                },
            };
            this.$emit('save', settings);
        },
    },
    watch: {
        initialSettings: {
            handler(newVal) {
                this.textColor = newVal.textColor || '#000000';
                this.backgroundColor = newVal.backgroundColor || '#ffffff';
                this.contentWidth = newVal.contentWidth || 500;
                this.fontFamily = newVal.fontFamily || 'Arial';
            },
            deep: true,
        },
    },
};
</script>

